import { PLAY_STORE_URL, APP_STORE_URL } from "../config";

export const GooglePlayIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path fill="#4285F4" d="M3.6 1.8C3.3 2.1 3 2.6 3 3.2v17.6c0 .6.3 1.1.6 1.4l.1.1L14.2 12v-.1L3.7 1.7l-.1.1z"/>
    <path fill="#34A853" d="M17.4 8.3L4.7 1.5c-.3-.2-.7-.1-1 .3L14.2 12l3.2-3.7z"/>
    <path fill="#FBBC04" d="M17.4 15.7l2.9-1.6c1.3-.8 1.3-3 0-3.8l-3-1.6-3.1 3.6 3.2 3.4z"/>
    <path fill="#EA4335" d="M17.4 15.7L14.2 12 3.7 22.3c.3.4.7.5 1 .3l12.7-6.9z"/>
  </svg>
);

export const AppleIcon = () => (
  <svg viewBox="0 0 384 512" width="24" height="24" fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
  </svg>
);

export default function StoreButtons({ highlight = false, idPrefix = "hero" }) {
  return (
    <div
      id={idPrefix === "hero" ? "descargar" : undefined}
      className={`store-buttons${highlight ? " cta-highlight" : ""}`}
      data-testid={`${idPrefix}-store-buttons`}
    >
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-btn"
        data-testid={`${idPrefix}-google-play-btn`}
      >
        <GooglePlayIcon />
        <span className="store-btn-text">
          <span className="store-btn-small">Descargar en</span>
          <span className="store-btn-big">Google Play</span>
        </span>
      </a>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-btn"
        data-testid={`${idPrefix}-app-store-btn`}
      >
        <AppleIcon />
        <span className="store-btn-text">
          <span className="store-btn-small">Descargar en</span>
          <span className="store-btn-big">App Store</span>
        </span>
      </a>
    </div>
  );
}
